import { Space, theme } from 'antd';
import { FC, memo } from 'react';
import { PatchCheckFill, PatchExclamationFill } from 'react-bootstrap-icons';


interface Props {
  isGoogleVerificated: boolean;
}

export const DomainGoogleVerificationTokenLabel: FC<Props> = memo(({ isGoogleVerificated }) => {
  const { token } = theme.useToken();

  return isGoogleVerificated
    ? <Space><PatchCheckFill color={ token.colorSuccess }/><span>Верифіковано</span></Space>
    : <Space><PatchExclamationFill color={ token.colorError }/><span>Не верифіковано</span></Space>;
});
